import { useSelector } from "react-redux";

import "./TabDetails.css";

import DeleteIcon from "../../static/image/deleteIcon.svg";
import CustomInput from "../../components/customInput/CustomInput";
import CommonCKEditor from '../../components/commonCKEditor/CommonCKEditor';

function Package({
  templateList,
  language,
  onInputChange,
  onShowUploadFile,
  onShowDeleteFile,
  packageData
}) {
  const { data, error } = useSelector((state) => state.package);

  const imageUrl = packageData?.imageUrl || data?.imageUrl;

  return (
    <>
      <div className="tab-package-container">
        {templateList.map((template, index) => {
          if (template.type === "text") {
            return (
              <div key={index} className="package-input">
                <label>
                  {template.label}
                  {template.required && (
                    <span className="required-asterisk">*</span>
                  )}
                  :
                </label>
                <CustomInput
                  type="text"
                  value={data?.[template.id] || ""}
                  onChange={(e) =>
                    onInputChange(template.id, e.target.value, language)
                  }
                  placeholder={template.placeholder[language]}
                  customStyle={{ width: "73%" }}
                  error={error?.[template.id]}
                />
              </div>
            );
          }

          if (template.type === "textarea") {
            return (
              <div key={index} className="package-input">
                <label>
                  {template.label}
                  {template.required && (
                    <span className="required-asterisk">*</span>
                  )}
                  :
                </label>
                <textarea
                  value={data?.[template.id] || ""}
                  onChange={(e) =>
                    onInputChange(template.id, e.target.value, language)
                  }
                  placeholder={template.placeholder[language]}
                ></textarea>
              </div>
            );
          }

          if (template.type === "file") {
            return (
              <div key={index} className="package-input">
                <label>
                  {template.label}
                  {template.required && (
                    <span className="required-asterisk">*</span>
                  )}
                  :
                </label>
                <div style={{ width: "73%" }}>
                  <div className="input-with-button">
                    <input
                      type="text"
                      placeholder={template.placeholder[language]}
                      value={data?.[template.id] || ""}
                      onChange={(e) => onInputChange(template.id, e.target.value)}
                      disabled
                    />
                    {!data?.[template.id] && (
                      <button
                        className="upload-btn"
                        onClick={() => onShowUploadFile(template.id)}
                      >
                        Upload
                      </button>
                    )}
                    {data?.[template.id] && (
                      <button
                        className="icon-btn"
                        onClick={() => onShowDeleteFile(template.id)}
                      >
                        <img
                          src={DeleteIcon}
                          alt="Delete"
                          className="action-icon"
                        />
                      </button>
                    )}
                  </div>

                  {template.id === "titleImageFileId" && imageUrl && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={imageUrl}
                        alt="Title Image"
                        style={{
                          maxWidth: "400px",
                          maxHeight: "400px",
                          border: "1px solid #ddd",
                          borderRadius: "4px"
                        }}
                        onError={(e) => {
                          console.error('Image failed to load:', imageUrl);
                          e.target.style.display = 'none';
                        }}
                        onLoad={() => console.log('Image loaded successfully')}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          }

          if (template.type === "radioGroup") {
            return (
              <div key={index} className="package-input">
                <label>
                  {template.label}
                  {template.required && (
                    <span className="required-asterisk">*</span>
                  )}
                  :
                </label>
                <div style={{ width: "73%", display: "flex", alignItems: "baseline" }}>
                  {template.options.map((option, idx) => (
                    <label key={idx} style={{ marginRight: "20px", display: "flex", alignItems: "center" }}>
                      <input
                        type="radio"
                        name={template.id}
                        checked={data?.[template.id] === option.value}
                        onChange={(e) => {
                          if (e.target.checked) {
                            onInputChange(template.id, option.value, language);
                          }
                        }}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginRight: "6px"
                        }}
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>
            );
          }

          if (template.type === "editor") {
            return (
              <div key={index} className="package-input">
                <label>
                  {template.label}
                  {template.required && (
                    <span className="required-asterisk">*</span>
                  )}
                  :
                </label>
                <div style={{ width: "73%" }}>
                  <CommonCKEditor
                    data={data?.[template.id] || ""}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      onInputChange(template.id, data, language);
                    }}
                    customStyle={{ width: "100%" }}
                  />
                </div>
              </div>
            );
          }

          return <></>;
        })}
      </div>
    </>
  );
}

export default Package;
